import * as React from 'react';
import { useGetRoleQuery } from "../../../apis/Role.api";
import { PrimaryRole, Role } from "../../../types/models/Role";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Role;
};

export const RoleNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const RoleName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetRoleQuery(PrimaryRole.fromId(id))
    return (<RoleNameDisplay data={data}/>)
}

export default RoleName;
